// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F4nB","footer":"styles_footer__2tut7","passCodeTooltip":"styles_passCodeTooltip__VYR2q"};